import "./Registration.module.css";
import MainNavigation from "@/reusable_sections/Header";
import CampSignUpForm from "./sections/CampSignUpForm";
import PaymentInstructions from "./sections/PaymentInstructions";
import FooterInformation from "@/reusable_sections/Footer";
export default function RegistrationPage() {
  return <div>
      <MainNavigation />
      <CampSignUpForm />
      <PaymentInstructions />
      <FooterInformation />
    </div>;
}